module.exports = __webpack_public_path__ + "static/media/DTBH03.7f98e713.jpg";